import React, { useEffect, useState } from "react";
import ApiURl from "../../controllers/Api";

export default function AdminPurities() {
  const [purities, setPurities] = useState([]);
  const [form, setForm] = useState({
    id: 0,
    name: "",
    is_active: 1,
    sort_order: 0,
  });
  const [message, setMessage] = useState("");

  const loadPurities = () => {
    fetch(`${ApiURl}/getPurities.php`)
      .then((res) => res.json())
      .then((data) => setPurities(data?.purities || []))
      .catch(() => setMessage("Unable to load purities."));
  };

  useEffect(() => {
    loadPurities();
  }, []);

  const savePurity = async (event) => {
    event.preventDefault();
    setMessage("");

    const response = await fetch(`${ApiURl}/savePurity.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const data = await response.json();

    setMessage(data?.message || "Saved.");

    if (data?.success) {
      setForm({
        id: 0,
        name: "",
        is_active: 1,
        sort_order: 0,
      });

      loadPurities();
    }
  };

  const resetForm = () => {
    setForm({
      id: 0,
      name: "",
      is_active: 1,
      sort_order: 0,
    });
    setMessage("");
  };

  return (
    <section className="admin-purities-luxury min-h-screen bg-[#F7EFE7] p-3 font-[kanit] text-[#2B0000] sm:p-5 lg:p-7">
      <div className="mx-auto max-w-6xl">
        <div className="overflow-hidden rounded-[26px] border border-[#d8c6b7] bg-[#fffaf5] shadow-[0_22px_60px_rgba(43,0,0,0.08)]">
          <div className="border-b border-[#e3d6cb] bg-[radial-gradient(circle_at_top_left,rgba(212,175,55,0.14),transparent_34%),linear-gradient(135deg,#fffaf5,#f2e6dc)] px-5 py-6 sm:px-7 sm:py-8">
            <div className="max-w-3xl">
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#9a7740]">
                Product Configuration
              </p>

              <h1 className="font-serif text-3xl font-medium tracking-tight text-[#2B0000] sm:text-4xl">
                Product Purities
              </h1>

              <p className="mt-3 text-sm leading-6 text-[#6f5e57]">
                Create reusable purities such as 18K and 22K, then assign
                product prices from the Add Product page.
              </p>
            </div>
          </div>

          <div className="p-4 sm:p-6 lg:p-7">
            <form
              onSubmit={savePurity}
              className="grid gap-4 rounded-[22px] border border-[#decfc3] bg-[linear-gradient(145deg,#fffaf5,#f3e8dd)] p-4 shadow-[0_16px_42px_rgba(43,0,0,0.06)] sm:p-5 md:grid-cols-[1fr_140px_150px_auto]"
            >
              <div>
                <label className="mb-2 block text-sm font-semibold text-[#4a352f]">
                  Purity Name
                </label>

                <input
                  value={form.name}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  placeholder="e.g. 22K"
                  className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition placeholder:text-[#8d7b73] focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
                  required
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-semibold text-[#4a352f]">
                  Sort Order
                </label>

                <input
                  type="number"
                  value={form.sort_order}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      sort_order: e.target.value,
                    }))
                  }
                  placeholder="0"
                  className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-semibold text-[#4a352f]">
                  Status
                </label>

                <select
                  value={form.is_active}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      is_active: Number(e.target.value),
                    }))
                  }
                  className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              <div className="flex items-end gap-2">
                <button
                  type="submit"
                  className="flex-1 rounded-xl bg-[#2B0000] px-5 py-3 text-sm font-semibold text-[#f4dfae] shadow-[0_12px_28px_rgba(43,0,0,0.16)] transition hover:-translate-y-0.5 hover:bg-[#4A090B] active:translate-y-[1px]"
                >
                  {form.id ? "Update" : "Add"}
                </button>

                {form.id ? (
                  <button
                    type="button"
                    onClick={resetForm}
                    className="rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm font-semibold text-[#2B0000] transition hover:bg-[#fff7ed]"
                  >
                    Cancel
                  </button>
                ) : null}
              </div>
            </form>

            {message ? (
              <div className="mt-5 rounded-2xl border border-[#d4af37]/25 bg-[#fff7e6] px-4 py-3 text-sm font-semibold text-[#7d5a19] shadow-[0_10px_25px_rgba(43,0,0,0.05)]">
                {message}
              </div>
            ) : null}

            <div className="mt-6 overflow-hidden rounded-[22px] border border-[#d8c6b7] bg-white shadow-[0_16px_42px_rgba(43,0,0,0.06)]">
              <div className="flex items-center justify-between border-b border-[#d8c6b7] bg-[#eee2d7] px-4 py-4 sm:px-5">
                <div>
                  <h2 className="font-serif text-xl font-medium text-[#2B0000]">
                    Available Purities
                  </h2>

                  <p className="mt-1 text-xs text-[#75645d]">
                    {purities.length} purity
                    {purities.length === 1 ? "" : "ies"} configured
                  </p>
                </div>
              </div>

              {purities.length === 0 ? (
                <div className="p-8 text-center">
                  <div className="mx-auto max-w-md rounded-2xl border-2 border-dashed border-[#d4af37]/30 bg-[#fbf3eb] p-7">
                    <p className="text-sm font-semibold text-[#4a352f]">
                      No purities found
                    </p>

                    <p className="mt-1 text-xs leading-5 text-[#7d6c64]">
                      Add your first purity using the form above.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="divide-y divide-[#eadfd5]">
                  {purities.map((purity) => {
                    const active = Number(purity.is_active) === 1;

                    return (
                      <div
                        key={purity.id}
                        className="grid gap-4 p-4 transition hover:bg-[#fff5ea] sm:p-5 md:grid-cols-[1fr_150px_140px] md:items-center"
                      >
                        <div className="min-w-0">
                          <div className="flex flex-wrap items-center gap-3">
                            <strong className="font-serif text-xl font-medium text-[#2B0000]">
                              {purity.name}
                            </strong>

                            <span className="rounded-full border border-[#d4af37]/25 bg-[#fff7e6] px-2.5 py-1 text-xs font-semibold text-[#7d5a19]">
                              #{purity.id}
                            </span>
                          </div>

                          <p className="mt-1 text-sm text-[#75645d]">
                            Sort order: {purity.sort_order || 0}
                          </p>
                        </div>

                        <div>
                          <span
                            className={
                              active
                                ? "inline-flex rounded-full border border-[#cfe2d1] bg-[#edf7ee] px-3 py-1.5 text-xs font-semibold text-[#47704e]"
                                : "inline-flex rounded-full border border-[#edcbc7] bg-[#fff0ee] px-3 py-1.5 text-xs font-semibold text-[#9d3d36]"
                            }
                          >
                            {active ? "Active" : "Inactive"}
                          </span>
                        </div>

                        <button
                          type="button"
                          onClick={() =>
                            setForm({
                              id: purity.id,
                              name: purity.name,
                              is_active: Number(purity.is_active),
                              sort_order: purity.sort_order || 0,
                            })
                          }
                          className="rounded-xl border border-[#d6c4b5] bg-white px-4 py-2.5 text-center text-sm font-semibold text-[#2B0000] shadow-sm transition hover:border-[#c59a4a] hover:bg-[#fff7ed]"
                        >
                          Edit Purity
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .admin-purities-luxury {
          background:
            radial-gradient(circle at 7% 0%, rgba(212, 175, 55, 0.1), transparent 28%),
            radial-gradient(circle at 95% 92%, rgba(43, 0, 0, 0.04), transparent 30%),
            #F7EFE7;
        }

        .admin-purities-luxury input,
        .admin-purities-luxury select,
        .admin-purities-luxury button {
          font: inherit;
        }

        .admin-purities-luxury ::selection {
          color: #fff7e7;
          background: #7a3131;
        }

        .admin-purities-luxury * {
          scrollbar-width: thin;
          scrollbar-color: rgba(143, 111, 56, 0.5)
            rgba(212, 175, 55, 0.07);
        }

        .admin-purities-luxury *::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .admin-purities-luxury *::-webkit-scrollbar-track {
          background: rgba(212, 175, 55, 0.07);
        }

        .admin-purities-luxury *::-webkit-scrollbar-thumb {
          border: 2px solid transparent;
          border-radius: 999px;
          background: rgba(143, 111, 56, 0.5);
          background-clip: padding-box;
        }

        @media (max-width: 640px) {
          .admin-purities-luxury {
            padding: 10px;
          }
        }
      `}</style>
    </section>
  );
}